<ul class="list-group-flush" [ngClass]="{'wrapColumn': shouldWrap}">
  <ng-container *ngFor="let lesson of lessons">
    <li class="list-group-item" [class.font-weight-bold]="item['id'] === lesson['id']">
      <span *ngIf="currentUser['role'] === 'TEACHER' || currentUser['role'] === 'EDITOR' || currentUser['role'] === 'ADMIN'">
        <ng-container *ngIf="currentStudentId">
          <a [routerLink]="['/les', lesson['id'], currentStudentId]" >
            {{lesson['name']}}
          </a>
        </ng-container>
        <ng-container *ngIf="!currentStudentId">
          <a [routerLink]="['/les', lesson['id']]" >
            {{lesson['name']}}
          </a>
        </ng-container>
      </span>
      <span *ngIf="currentUser['role'] === 'STUDENT' || !currentUser">
        <a [routerLink]="['/les', lesson['id']]" >
          {{lesson['name']}}
        </a>
      </span>
    </li>
  </ng-container>
</ul>
